// Onboarding events (guided first visit). No vendor and nothing sent yet:
// the API has no events or usage-event endpoint. Until it does, events go
// only to in-page listeners (tests); nothing is logged.
//
// TODO(server, owner James): POST /api/v2/me/events { name, props, at }
// stored per account (no visit content, no PHI); then send from here with
// the oRPC client, fire-and-forget. See GUIDED-PR.md, "Server side".

export type OnboardingEventName =
  | "welcome_completed"
  | "practice_started"
  | "practice_submitted"
  | "practice_note_opened"
  | "practice_flag_added"
  | "coach_step_viewed"
  | "coach_step_skipped"
  | "coach_skipped"
  | "coach_completed"
  | "verify_reviewed"
  | "note_copied"
  | "emr_panel_shown"
  | "extension_install_clicked"
  | "checklist_item_done"
  | "checklist_dismissed"
  | "checklist_completed"
  | "create_template_opened";

export type OnboardingEventProps = Record<string, string | number | boolean>;
export interface OnboardingEvent {
  name: OnboardingEventName;
  props: OnboardingEventProps;
  at: number;
}
type Listener = (event: OnboardingEvent) => void;
const listeners = new Set<Listener>();

export const trackOnboarding = (
  name: OnboardingEventName,
  props: OnboardingEventProps = {},
): void => {
  const event = { name, props, at: Date.now() };
  for (const listener of listeners) {
    try {
      listener(event);
    } catch {
      // A listener never breaks the flow.
    }
  }
};

export const onOnboardingEvent = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
